import { ROW_STATE } from "../components/forms/formConstants.js";

export function splitByRowState(entities, name) {
  const result = {
    new: [],
    existing: [],
    edited: [],
    deleted: []
  };

  for (let i = 0; i < entities.length; i++) {
    const entity = entities[i];
    entity.fieldPath = `${name}[${i}]`;

    switch (entity.state) {
      case ROW_STATE.NEW:
        result.new.push(entity);
        break;
      case ROW_STATE.APPLY_EXISTING:
        result.existing.push(entity);
        break;
      case ROW_STATE.EDIT:
        result.edited.push(entity);
        break;
      case ROW_STATE.DELETE:
        result.deleted.push(entity);
        break;
    }
  }

  return result;
}
